import { render, staticRenderFns } from "./ItemAuctionSaveLayout.vue?vue&type=template&id=d0bb0ca6&scoped=true"
import script from "./ItemAuctionSaveLayout.vue?vue&type=script&lang=js"
export * from "./ItemAuctionSaveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bb0ca6",
  null
  
)

export default component.exports